import { Link } from "react-router-dom";
import { EDITOR_ROLES } from "@shared/core/types";
import type { CvAnalysis } from "@shared/modules/x-extraction";
import { useAuthStore } from "../../../core/stores/auth";
import { Modal } from "../../../core/components/ui/modal";
import { allowedFor } from "../../../core/modules";
import { documentUrl } from "../lib/api";
import { ProfileView } from "./profile-view";

/** La fiche synthèse en surimpression, avec ce qu'on peut en faire : lire le CV, créer le dossier. */
export function ProfileModal({ analysis, onClose }: { analysis: CvAnalysis | null; onClose: () => void }) {
  const user = useAuthStore((s) => s.user);
  const canEdit = allowedFor({ roles: EDITOR_ROLES }, user?.role);
  return (
    <Modal
      open={analysis !== null}
      size="lg"
      title="Fiche synthèse"
      onClose={onClose}
      footer={
        analysis ? (
          <>
            <a className="btn btn--ghost" href={documentUrl(analysis.documentId, true)} target="_blank" rel="noreferrer">
              Voir le CV d'origine
            </a>
            {analysis.candidateId ? (
              <Link className="btn btn--primary" to={`/candidats/${analysis.candidateId}`}>
                Voir le dossier
              </Link>
            ) : canEdit && analysis.status === "a_valider" ? (
              <Link className="btn btn--primary" to={`/importations/${analysis.jobId}`}>
                Créer le dossier
              </Link>
            ) : null}
          </>
        ) : null
      }
    >
      {analysis ? <ProfileView analysis={analysis} /> : null}
    </Modal>
  );
}
